export default "__VITE_ASSET__BeYxDtuN__"